/* import __COLOCATED_TEMPLATE__ from './body.hbs'; */
import { MODE_APPOINTMENT } from 'client-portal/utils/prescreener/constants';
import { and, empty } from '@ember/object/computed';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
@tagName('')
export default class RequestRequestWrapperBody extends Component {
  @service currentPractice;
  @service session;
  @service prescreener;

  get modeAppointment() {
    return MODE_APPOINTMENT;
  }

  @empty('session.currentClient') isNewClient;
  @computed('activeSteps.@each.isActive')
  get isFirstStep() {
    return this.activeSteps?.at(0)?.isActive;
  }
  @and('isNewClient', 'isFirstStep') showSignInBox;
}
